<template>
  <div :class="postShowMediaClasses">
    <PostPlayer :post="post" v-if="showPlayer" />
    <PostHero :post="post" v-if="!showPlayer" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import PostPlayer from '@/post/player/post-player';
import PostHero from '@/post/components/post-hero';
// import { getImageBase64 } from '@/file/file.service';

export default defineComponent({
  name: 'PostShowMedia',

  /**
   * 属性
   */
  props: {
    post: {
      type: Object,
    },
  },

  /**
   * 数据
   */
  data() {
    return {
      loading: false,
      image: null,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    postShowMediaClasses() {
      return ['post-show-media', { loading: this.loading }];
    },

    showPlayer() {
      return this.post.video.stream && this.post.video.stream.length;
    },
  },

  /**
   * 已创建
   */
  async created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    onLoadImage() {
      this.loading = false;
    },
  },

  /**
   * 使用组件
   */
  components: { PostPlayer, PostHero },
});
</script>

<style scoped>
@import './styles/post-show-media.css';
</style>
